module.exports = __webpack_public_path__ + "img/planetmg-logo.9d3485dc.svg";